import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

export const Root = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${uiToken.color.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${uiToken.color.background.main};
`;
